import Vue from 'vue'
import storage from '@/services/storage'

const setSlides = (state, payload) => {
  state.slides = payload
}

const setSlidesList = (state, payload) => {
  Vue.set(state, 'slidesList', payload)
  state.slidesList = payload
}

const setSlideIndex = (state, payload) => {
  if (!state.presentation || !state.presentation.id || payload == -1) return
  state.slideIndex = payload
}

const setMaxLookbackSlideIndex = (state, payload) => {
  if (payload > state.maxLookbackSlideIndex) {
    state.maxLookbackSlideIndex = payload
    storage.setValueByPresentation(state.presentation.id, 'maxLookbackSlideIndex', payload)
  }
}

export default {
  setSlides,
  setSlidesList,
  setSlideIndex,
  setMaxLookbackSlideIndex,
}
